





































import Vue from 'vue';
import { IAnotherOtherCustomSelectOption } from '../../../common/interfaces/shared.interface';

interface ISelectInputComponent {
  initialized: boolean;
}

export default Vue.extend({
  model: {
    event: `change`,
    prop: `value`,
  },
  data(): ISelectInputComponent {
    return {
      initialized: false,
    };
  },
  props: {
    disabled: {
      default: false,
      type: Boolean,
    },
    identifier: {
      default: ``,
      type: String,
    },
    options: {
      default() { return []; },
      type: Array as () => IAnotherOtherCustomSelectOption[],
    },
    required: {
      default: false,
      type: Boolean,
    },
    showEmptyOption: {
      default: false,
      type: Boolean,
    },
    showError: {
      default: false,
      type: Boolean,
    },
    t: {
      required: true,
      type: Object,
    },
    testSelector: {
      default: ``,
      type: String,
    },
    title: {
      default: ``,
      type: String,
    },
    value: {
      default: ``,
      type: [String, Number],
    },
  },
  mounted(): void {
    let selectMenuInitTries = 0;
    const selectMenuInitInterval = window.setInterval(() => {
      if(this.$refs.selectElement) {
        window.clearInterval(selectMenuInitInterval);
        const $variantsSelect = $(this.$refs.selectElement);

        /* eslint-disable @typescript-eslint/ban-ts-comment */
        // @ts-ignore
        $variantsSelect.selectmenu({
          // @ts-ignore
          change: (_event, ui) => { this.emitChangedValue(ui.item.value); },
          width: true,
        });
        // @ts-ignore
        $variantsSelect.selectmenu(`widget`).addClass(`ui-button select-input__selectmenu`);
        // @ts-ignore
        $variantsSelect.selectmenu(`widget`).attr(`data-cy`, this.testSelector);
        this.initialized = true;
        if(this.options.length === 0) {
          return;
        }
        // @ts-ignore
        $variantsSelect.val(this.value).selectmenu(`refresh`);
      } else if(selectMenuInitTries < 5) {
        selectMenuInitTries++;
      }
      /* eslint-enable */
    }, 1000);
  },
  methods: {
    emitChangedValue(value: string): void {
      if(!this.disabled) {
        this.$emit(`change`, value);
      }
    },
  },
  watch: {
    disabled(): void {
      this.$nextTick(() => {
        // This is to ignore errors for JQuery legacy code
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if(this.initialized) $(this.$refs.selectElement).val(this.value).selectmenu(`refresh`);
      });
    },
    options(): void {
      this.$nextTick(() => {
        // This is to ignore errors for JQuery legacy code
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        if(this.initialized) $(this.$refs.selectElement).val(this.value).selectmenu(`refresh`);
      });
    },
    value(val): void {
      if(this.options.length === 0) return;
      this.$nextTick(() => {
        if(this.initialized) {
          if(this.$refs.selectElement) {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            $(this.$refs.selectElement).val(val).selectmenu(`refresh`);
          }
        }
      });
    },
  },
});
